import {
  SketchEntitiesTransformCommand,
  canShowSketchPropertySection,
  registerPropertyManagerSection,
} from '@/core';
import SketchMoveEntitiesPropertySection from '@/components/editor/property-manager/entities-transform/SketchMoveEntitiesPropertySection.vue';

registerPropertyManagerSection({
  id: 'sketch-move-entities',
  title: '移动实体',
  order: 18,
  component: SketchMoveEntitiesPropertySection,
  exclusive: true,
  actions: {
    confirm: true,
    cancel: true,
  },
  resolveConfirmDisabled: (context) => context.sketchEntitiesTransformState?.canConfirm === false,
  isApplicable: (context) => {
    return canShowSketchPropertySection(
      context,
      context.isSketchActive
        && context.activeCommand === SketchEntitiesTransformCommand.Move
        && context.sketchEntitiesTransformState?.active === true,
    );
  },
  onConfirm: (context) => {
    void context.confirmSketchEntitiesTransform?.();
  },
  onCancel: (context) => {
    context.cancelSketchEntitiesTransform?.();
  },
});
